export default __webpack_public_path__ + "static/media/YorkUni.fc2cfe08.png";